export const VISITS_FREQUENCY = {
  LESS_THAN_1: "<1",
  BETWEEN_1_AND_20: "1 - 20",
  BETWEEN_20_AND_40: "20 - 40",
  GREATER_THAN_40: ">40",
};

export const FREQUENCY_VISITS = {
  LESS_THAN_1: "0",
  BETWEEN_1_AND_2: "1 - 2",
  BETWEEN_3_AND_5: "3 - 5",
  BETWEEN_6_AND_8: "6 - 8",
  GREATER_THAN_9: "9+",
};

export const VISIT_DURATION = {
  LESS_THAN_2: "<2 mins",
  BETWEEN_2_AND_10: "2 - 10 mins",
  BETWEEN_10_AND_20: "10 - 20 mins",
  GREATER_THAN_20: ">20 mins",
};

const _currentYear = new Date().getFullYear();
export const YEAR_OPTIONS = Array.from(
  { length: _currentYear - 2019 },
  (_, i) => {
    const year = String(_currentYear - i);
    return { text: year, value: year };
  }
);

export const MONTH_OPTIONS = [
  { text: "January", value: "01" },
  { text: "February", value: "02" },
  { text: "March", value: "03" },
  { text: "April", value: "04" },
  { text: "May", value: "05" },
  { text: "June", value: "06" },
  { text: "July", value: "07" },
  { text: "August", value: "08" },
  { text: "September", value: "09" },
  { text: "October", value: "10" },
  { text: "November", value: "11" },
  { text: "December", value: "12" },
];

export const ROLLING_AVG = "rollingaverage";
